import { type ElementType, type ReactElement } from "react";

import { styled } from "simplydo/react/styled";

import { TextArea } from "../textarea/TextArea";
import type { FormTextAreaProps } from "./Form.types";
import { FormField } from "./FormField";

const FormTextAreaComponent = (props: FormTextAreaProps): ReactElement => {
  const { control, ...rest } = props;
  return <FormField {...rest} control={(control as ElementType) || TextArea} />;
};

export const FormTextArea = styled(FormTextAreaComponent)``;
